export const MINYANIM_TEXT_EDITOR_FONT_OPTIONS = [
  { label: 'Tzlilim', value: 'TzlilimPM, sans-serif' },
  { label: 'Pyutim', value: 'Pyutim, sans-serif' },
  { label: 'FrankRuhl', value: 'FrankRuhl, serif' },
  { label: 'FbFrank', value: 'FbFrank, sans-serif' },
  { label: 'NRKis', value: 'NRKis, sans-serif' },
  { label: 'BAHaYetzira', value: 'BAHaYetzira, sans-serif' },
  { label: 'BAHaYetzira Bold', value: 'BAHaYetzira-Bold, sans-serif' },
  { label: 'BULeshem', value: 'BULeshem, sans-serif' },
  { label: 'BULeshem Bold', value: 'BULeshem-Bold, sans-serif' },
  { label: 'EFTVilna', value: 'EFTVilna, sans-serif' },
  { label: 'EFTVilna Bold', value: 'EFTVilna-Bold, sans-serif' },
  { label: 'FBShefa', value: 'FBShefa, sans-serif' },
  { label: 'FBVilna', value: 'FBVilna, sans-serif' },
  { label: 'FBVilna Bold', value: 'FBVilna-Bold, sans-serif' },
  { label: 'Shefa', value: 'Shefa, sans-serif' },
  { label: 'Shefa Bold', value: 'Shefa-Bold, sans-serif' },
  { label: 'ShefaClassicBold', value: 'ShefaClassicBold, sans-serif' },
];

// Hebrew display fonts shared by the minyanim-roll design cards (List,
// Underline, and Header Grouping fonts). Values are the bare font-family
// names declared in assets/style/index.css.
export const MINYANIM_ROLL_TEXT_FONT_OPTIONS = [
  { label: 'Tzlilim', value: 'TzlilimPM' },
  { label: 'Pyutim', value: 'Pyutim' },
  { label: 'FrankRuhl', value: 'FrankRuhl' },
  { label: 'FbFrank', value: 'FbFrank' },
  { label: 'NRKis', value: 'NRKis' },
  { label: 'BAHaYetzira', value: 'BAHaYetzira' },
  { label: 'BAHaYetzira Bold', value: 'BAHaYetzira-Bold' },
  { label: 'BULeshem', value: 'BULeshem' },
  { label: 'BULeshem Bold', value: 'BULeshem-Bold' },
  { label: 'EFTVilna', value: 'EFTVilna' },
  { label: 'EFTVilna Bold', value: 'EFTVilna-Bold' },
  { label: 'FBShefa', value: 'FBShefa' },
  { label: 'FBVilna', value: 'FBVilna' },
  { label: 'FBVilna Bold', value: 'FBVilna-Bold' },
  { label: 'Shefa', value: 'Shefa' },
  { label: 'Shefa Bold', value: 'Shefa-Bold' },
  { label: 'ShefaClassicBold', value: 'ShefaClassicBold' },
];

export const MINYANIM_TEXT_EDITOR_ZOOM_OPTIONS = [50, 75, 100, 125, 150, 200];

export const ZMANIM_N_FONT_SIZE_OPTIONS = [
  10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 36, 40, 44, 48,
  56, 64, 72, 80, 88, 96, 110, 120, 140, 160, 180, 200, 220, 240, 260, 280, 300,
];

export const MINYANIM_ROLL_LINE_HEIGHT_OPTIONS = [0.6, 0.7, 0.8, 1, 1.15, 1.25, 1.5, 1.75, 2, 2.5, 3];
